<button class="image-upload inputFile" style="width: 100%;height: 100%" (click)="fileInput.click()"
  [disabled]="uploadDisabled">
  <div class="flex-between-center">
    @if ((imageNotSet$|async) == false) {
      <div class="image-home" (click)="$event.stopPropagation();openFullImage(ImageContainer)">
        <img
          [src]="(url)"
          class="object-fit_cover w100">
      </div>
    }
    <div style="flex-grow: 1">
      <div class="flex-start-start flex-direction-column w100 padding">
        @if (title) {
          <span class="w100 "
            style="font-size: small;font-weight:bold;text-align: center"
          >{{ title }}</span>
        }
        <div class="w100 "
          style="text-align: center">
          @if (!loadImage&&!loading) {
            {{ 'fileManager.copyFile' | translate }}
          } @else {
            <mat-progress-bar style="margin-bottom: 5px" mode="indeterminate"></mat-progress-bar>
          }
        </div>
      </div>
    </div>
    <div>
      <button mat-icon-button color="warn" [disabled]="uploadDisabled||(imageNotSet$|async)"
        (click)="$event.stopPropagation();deleteImage()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <input type="file" [accept]="accept" #fileInput (change)="importFile($event)" multiple>
</button>


<ng-template #ImageContainer>
  <div style="position: absolute;top: 0;right: 0;z-index: 9">
    <button mat-icon-button color="primary" [mat-dialog-close]="undefined">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <app-pinch-to-zoom [properties]="pzProperties">
    <img [src]="url" class="img-object-fit-scale-down" style="height:100%">
  </app-pinch-to-zoom>
</ng-template>